module.exports = __webpack_public_path__ + "static/media/InstawearPoster.9b7b4f44.jpg";